/* eslint-disable max-len */

import type { MessageSchema } from '@/i18n/types';

const kk: MessageSchema['leads'] = {
    appeal: {
        error:             'Апелляцияны жіберу мүмкін болмады, қайта байқап көріңіз',
        reasonPlaceholder: 'Себебін көрсетіңіз',
        title:             'Апелляцияға өтінім',
    },
    chart: {
        downloadExcel: 'Excel жүктеп алу',
        title:         {
            last30Days: 'Соңғы 30 күндегі барлық лидтер',
            last7Days:  'Соңғы 7 күндегі барлық лидтер',
            lastMonth:  'Өткен айдағы барлық лидтер',
            lastWeek:   'Өткен аптадағы барлық лидтер',
            range:      '{range} аралығындағы барлық лидтер',
            thisMonth:  'Осы айдағы барлық лидтер',
            thisWeek:   'Осы аптадағы барлық лидтер',
        },
        total: 'Барлық лидтер',
    },
    export: {
        downloaded: 'Есеп жүктелді',
        fileName:   'Есеп {name} {from}-{to}',
        heading:    {
            comment: 'Пікір',
            date:    'Күн, уақыт',
            name:    'Аты',
            payment: 'Төлем',
            phone:   'Телефон нөмірі',
            status:  'Мәртебесі',
            type:    'Өтінімнің түрі',
        },
        loadError:   'Деректерді жүктеу мүмкін болмады, кейінірек қайталап көріңіз',
        noRequests:  'Сәйкес өтінімдер жоқ.\nСүзгі параметрлерін өзгертіп көріңіз',
        payment:     'Төлем',
        requestType: {
            call:       'Қоңырау',
            form:       'Кері байланыс формасы арқылы өтінім',
            missedCall: 'Қабылданбаған қоңырау',
        },
        sheetName: 'Тізім',
        statuses:  'Мәртебелер',
        title:     'Есепті жүктеп алу',
        type:      'Түрлері',
    },
    filters: {
        allAgents:  'Барлығы',
        clearPhone: 'Нөмірді тазалау',
        payment:    {
            any:     'Кез келген төлем',
            notPaid: 'Төленбеген',
            paid:    'Төленген',
        },
        phone:  'Телефон нөмірі',
        status: {
            all:         'Барлық мәртебелер',
            appeal:      'Апелляцияда',
            duplicate:   'Қайталанғандар',
            target:      'Мақсатты',
            unearmarked: 'Мақсатты емес',
        },
        type: {
            all: 'Барлық түрлері',
        },
    },
    list: {
        call:             'Қоңырау',
        commentError:     'Пікірді сақтау мүмкін болмады',
        declineError:     'Апелляциядан алып тастау мүмкін болмады',
        details:          'Толығырақ',
        emptyText:        'Клиенттер қоңырау шалып, өтінім қалдыра бастағанда, оларды осы жерден көресіз',
        emptyTitle:       'Әзірге лидтер жоқ',
        form:             'Өтінім',
        lead:             'Лид',
        missedCall:       'Өткізіп алынған қоңырау',
        removeAppeal:     'Апелляциядан алып тастау',
        statusAndPayment: 'Мәртебесі және төлемі',
        submitAppeal:     'Апелляция беру',
    },
    payments: {
        notPaid: 'Төленбеген',
        paid:    'Төленген',
    },
    statuses: {
        appeal:      'Апелляцияда',
        duplicate:   'Қайталанған',
        target:      'Мақсатты',
        unearmarked: 'Мақсатты емес',
    },
};

export default kk;
